'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES = 'Yes';
var NO = 'No';
var NO_FILL = 'Planned meals, but didn\'t fill out the sheet';
var PLANNED = 'Already have a meal planning system in place';
var NO_OPT = 'I didn\'t opt in to do the activity';

var Module3App1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    profile: state.profile.data,
    allModule: state.moduleData.data.module3,
    app: state.moduleData.data.module3.app1
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module3App1, _Component);

  function Module3App1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module3App1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module3App1.__proto__ || (0, _getPrototypeOf2.default)(Module3App1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 3,
      appId: 1,
      title: 'Recap from Module 2',
      isCompleted: _this.props.app.isCompleted || false,
      tryAndChopVege: _this.props.app.tryAndChopVege || '', // last week were you able to try and chop vegetables
      vegecut: _this.props.app.vegecut || '', // what vegetable did i cut up
      didChildEatVege: _this.props.app.didChildEatVege || '', // did your child eat it
      doDifferently: _this.props.app.doDifferently || '', // what could you do differently
      tryPlan: _this.props.app.tryPlan || '', // were you able to try out meal planner
      workWell: _this.props.app.workWell || '', // did it work well
      tryAgain: _this.props.app.tryAgain || '', // will you try it again
      keepInMind: _this.props.app.keepInMind || '', // anything you could do to plan meals and shopping lists
      didTryPlan: _this.props.app.didTryPlan || '', // did you try the meal planner
      wasHelpful: _this.props.app.wasHelpful || '', // was it wasHelpful
      // tv related recap
      ableToEatWithoutTV: _this.props.app.ableToEatWithoutTV || '', // were you able to eat without the tv
      tvPleasant: _this.props.app.tvPleasant || '', // was it a pleasant experience
      didTalkMore: _this.props.app.didTalkMore || '', // did you find you talked more
      differentToIncSuccess: _this.props.app.differentToIncSuccess || '', // If you can give it another try, can you think of anything that you would do
      // differently to increase your chances of success?
      doSomethingDifferent: _this.props.app.doSomethingDifferent || '' // do something differently
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.handletryAndChopVege = function (event) {
      var obj = _this.state;
      obj.tryAndChopVege = event.target.value;
      obj.vegecut = '';
      obj.didChildEatVege = '';
      obj.doDifferently = '';
      obj.tryPlan = '';
      obj.workWell = '';
      obj.tryAgain = '';
      obj.keepInMind = '';
      obj.didTryPlan = '';
      obj.wasHelpful = '';
      obj.ableToEatWithoutTV = '';
      obj.tvPleasant = '';
      obj.didTalkMore = '';
      obj.differentToIncSuccess = '';
      obj.doSomethingDifferent = '';
      _this.setState(obj);
    }, _this.handledidChildEatVege = function (event) {
      var obj = _this.state;
      obj.didChildEatVege = event.target.value;
      obj.doDifferently = '';
      obj.tryPlan = '';
      obj.workWell = '';
      obj.tryAgain = '';
      obj.keepInMind = '';
      obj.didTryPlan = '';
      obj.wasHelpful = '';
      obj.ableToEatWithoutTV = '';
      obj.tvPleasant = '';
      obj.didTalkMore = '';
      obj.differentToIncSuccess = '';
      obj.doSomethingDifferent = '';
      _this.setState(obj);
    }, _this.handleTryPlan = function (event) {
      var obj = _this.state;
      obj.tryPlan = event.target.value;
      obj.workWell = '';
      obj.tryAgain = '';
      obj.keepInMind = '';
      obj.didTryPlan = '';
      obj.wasHelpful = '';
      obj.ableToEatWithoutTV = '';
      obj.tvPleasant = '';
      obj.didTalkMore = '';
      obj.differentToIncSuccess = '';
      obj.doSomethingDifferent = '';
      _this.setState(obj);
    }, _this.handleWorkWell = function (event) {
      var obj = _this.state;
      obj.workWell = event.target.value;
      obj.tryAgain = '';
      obj.keepInMind = '';
      obj.didTryPlan = '';
      obj.wasHelpful = '';
      obj.ableToEatWithoutTV = '';
      obj.tvPleasant = '';
      obj.didTalkMore = '';
      obj.differentToIncSuccess = '';
      obj.doSomethingDifferent = '';
      _this.setState(obj);
    }, _this.handleTryAgain = function (event) {
      var obj = _this.state;
      obj.tryAgain = event.target.value;
      obj.keepInMind = '';
      obj.didTryPlan = '';
      obj.wasHelpful = '';
      obj.ableToEatWithoutTV = '';
      obj.tvPleasant = '';
      obj.didTalkMore = '';
      obj.differentToIncSuccess = '';
      obj.doSomethingDifferent = '';
      _this.setState(obj);
    }, _this.handleKeepInMind = function (event) {
      var obj = _this.state;
      obj.keepInMind = event.target.value;
      obj.didTryPlan = '';
      obj.wasHelpful = '';
      obj.ableToEatWithoutTV = '';
      obj.tvPleasant = '';
      obj.didTalkMore = '';
      obj.differentToIncSuccess = '';
      obj.doSomethingDifferent = '';
      _this.setState(obj);
    }, _this.handleDidTryPlan = function (event) {
      var obj = _this.state;
      obj.didTryPlan = event.target.value;
      obj.wasHelpful = '';
      obj.ableToEatWithoutTV = '';
      obj.tvPleasant = '';
      obj.didTalkMore = '';
      obj.differentToIncSuccess = '';
      obj.doSomethingDifferent = '';
      _this.setState(obj);
    }, _this.handlewasHelpful = function (event) {
      var obj = _this.state;
      obj.wasHelpful = event.target.value;
      obj.ableToEatWithoutTV = '';
      obj.tvPleasant = '';
      obj.didTalkMore = '';
      obj.differentToIncSuccess = '';
      obj.doSomethingDifferent = '';
      _this.setState(obj);
    }, _this.handleableToEatWithoutTV = function (event) {
      var obj = _this.state;
      obj.ableToEatWithoutTV = event.target.value;
      obj.tvPleasant = '';
      obj.didTalkMore = '';
      obj.differentToIncSuccess = '';
      obj.doSomethingDifferent = '';
      _this.setState(obj);
    }, _this.handleTVPleasant = function (event) {
      var obj = _this.state;
      obj.tvPleasant = event.target.value;
      obj.didTalkMore = '';
      obj.differentToIncSuccess = '';
      obj.doSomethingDifferent = '';
      _this.setState(obj);
    }, _this.handledidTalkMore = function (event) {
      var obj = _this.state;
      obj.didTalkMore = event.target.value;
      obj.differentToIncSuccess = '';
      obj.doSomethingDifferent = '';
      _this.setState(obj);
    }, _this.handledifferentToIncSuccess = function (event) {
      var obj = _this.state;
      obj.differentToIncSuccess = event.target.value;
      obj.doSomethingDifferent = '';
      _this.setState(obj);
    }, _this.handledoSomethingDifferent = function (event) {
      var obj = _this.state;
      obj.doSomethingDifferent = event.target.value;
      _this.setState(obj);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * User types in something for what was
   * involved in the diet
   */


  (0, _createClass3.default)(Module3App1, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 3'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, lg: 12, sm: 12 },
              _react2.default.createElement(
                'p',
                null,
                'Before we begin today\'s session, let\'s recap what we covered in the previous module.'
              ),
              _react2.default.createElement(
                'h3',
                null,
                'Chop up fresh fruit and vegetables'
              ),
              _react2.default.createElement(
                'h5',
                null,
                'Last week you were going to try and chop up fruit and vegetables as snacks for your child. Were you able to do this?'
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handletryAndChopVege.bind(this) },
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'tryAndChopVege', value: YES, checked: this.state.tryAndChopVege === YES },
                  YES
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'tryAndChopVege', value: NO, checked: this.state.tryAndChopVege === NO },
                  NO
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'tryAndChopVege', value: NO_OPT, checked: this.state.tryAndChopVege === NO_OPT },
                  NO_OPT
                )
              ),
              this.state.tryAndChopVege === YES && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s great to hear, what did you cut up?'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text',
                  placeholder: 'What vegetable I cut up...', value: this.state.vegecut, onChange: this.handleChange.bind(this, 'vegecut') }),
                _react2.default.createElement('br', null)
              ),
              this.state.vegecut && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'Did your child eat it?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handledidChildEatVege.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'didChildEatVege', value: YES, checked: this.state.didChildEatVege === YES || this.state.didChildEatVege == 1 },
                    YES
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'didChildEatVege', value: NO, checked: this.state.didChildEatVege === NO || this.state.didChildEatVege == 0 },
                    NO
                  )
                )
              ),
              this.state.didChildEatVege === YES && _react2.default.createElement(
                'p',
                null,
                'That\'s great, if you keep providing healthy options it\'s likely that ',
                this.props.profile.childName,
                ' will try them and get to like them.'
              ),
              (this.state.didChildEatVege === NO || this.state.tryAndChopVege === NO) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s a shame. That sounds like it could have been frustrating, but you did the right thing and provided ready-to-eat healthy foods in an appealing way. If you providing healthy options it\'s likely that ',
                  this.props.profile.childName,
                  ' will try them and get to like them.'
                )
              ),
              _react2.default.createElement('div', { className: styles.spacer20 }),
              (this.state.didChildEatVege || this.state.tryAndChopVege === YES && this.state.didChildEatVege == 0 || this.state.tryAndChopVege === NO || this.state.tryAndChopVege === NO_OPT) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h3',
                  null,
                  'Meal planning'
                ),
                _react2.default.createElement(
                  'h5',
                  null,
                  'We talked about meal planning, and suggested that you try the meal planner. Were you able to try out the meal planner this past week?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleTryPlan.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'tryPlan', value: YES, checked: this.state.tryPlan === YES },
                    YES
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'tryPlan', value: NO, checked: this.state.tryPlan === NO },
                    NO
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'tryPlan', value: NO_FILL, checked: this.state.tryPlan === NO_FILL },
                    NO_FILL
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'tryPlan', value: PLANNED, checked: this.state.tryPlan === PLANNED },
                    PLANNED
                  )
                )
              ),
              this.state.tryPlan === YES && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'Did it work well?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleWorkWell.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'workWell', value: YES, checked: this.state.workWell === YES },
                    YES
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'workWell', value: NO, checked: this.state.workWell === NO },
                    NO
                  )
                )
              ),
              this.state.workWell === YES && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s great!'
                )
              ),
              this.state.workWell === NO && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s a shame that the planner didn\'t work so well for you this week. Deciding on meals in advance can be difficult.'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text',
                  placeholder: 'What could I do differently...', value: this.state.doDifferently, onChange: this.handleChange.bind(this, 'doDifferently') })
              ),
              this.state.workWell && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'Will you try it again?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleTryAgain.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'tryAgain', value: YES, checked: this.state.tryAgain === YES },
                    YES
                  ),
                  this.state.tryAgain === YES && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'We hope you are able to use a similar structure to help plan your meals and shopping lists.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'tryAgain', value: NO, checked: this.state.tryAgain === NO },
                    NO
                  ),
                  this.state.tryAgain === NO && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'That\'s ok, meal planning is useful for some people but it\'s not for everyone. It\'s a process of finding out what works for you and your family.'
                    )
                  )
                )
              ),
              this.state.tryPlan === NO && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'Although meal planning is useful for some people, it\'s not for everyone. I would encourage you to try it a couple more times and then decide if it works for you.'
                ),
                _react2.default.createElement(
                  'h5',
                  null,
                  'Keeping in mind the reasons why it wasn\'t possible this past week, can you think of anything you could do to help you plan meals and shopping?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleKeepInMind.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'keepInMind', value: YES, checked: this.state.keepInMind === YES },
                    YES
                  ),
                  this.state.keepInMind === YES && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'Perhaps you could make a note of those ideas somewhere.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'keepInMind', value: 'Trying', checked: this.state.keepInMind === 'Trying' },
                    'Trying to think of something but can\'t make suggestions'
                  ),
                  this.state.keepInMind === 'Trying' && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'There\'s no rush. Whenever you do think of anything, perhaps you could make a note of these ideas somewhere.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'keepInMind', value: NO, checked: this.state.keepInMind === NO },
                    NO
                  ),
                  this.state.keepInMind === NO && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'Meal planning is useful for some people but it\'s not for everyone. It\'s a process of finding what works best for you and your family.'
                    )
                  )
                )
              ),
              this.state.tryPlan === NO_FILL && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s great that you were able to plan some meals. Writing out a meal plan and shopping list is useful for some people, but it\'s not for everyone. If what you are doing now is working well, that\'s great. If not, it would be a good idea to try filling in the planner a couple of times and then decide if it is working for you.'
                )
              ),
              this.state.tryPlan === PLANNED && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'Last week we talked about meal planning and you indicated that you already plan your meals and shopping lists ahead of time, which is fantastic. Did you try the meal planner that we provided?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleDidTryPlan.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'didTryPlan', value: YES, checked: this.state.didTryPlan === YES },
                    YES
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'didTryPlan', value: NO, checked: this.state.didTryPlan === NO },
                    NO
                  )
                )
              ),
              this.state.didTryPlan === YES && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s great!'
                ),
                _react2.default.createElement(
                  'h5',
                  null,
                  'Was it helpful?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handlewasHelpful.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'wasHelpful', value: YES, checked: this.state.wasHelpful === YES },
                    YES
                  ),
                  this.state.wasHelpful === YES && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'I\'m glad you liked the meal planner and hope you\'ll be able to use it regularly.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'wasHelpful', value: NO, checked: this.state.wasHelpful === NO },
                    NO
                  ),
                  this.state.wasHelpful === NO && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'It was great that you gave the meal planner a test run. It is just one way of meal planning.'
                    )
                  )
                )
              ),
              this.state.didTryPlan === NO && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'Meal planning is useful for some people but it\'s not for everyone. It\'s a process of finding what works best for you and your family.'
                )
              ),
              (this.state.tryPlan === NO_FILL || this.state.tryAgain || this.state.keepInMind || this.state.wasHelpful || this.state.didTryPlan === NO) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h3',
                  null,
                  'Eating as a family without the TV'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We talked in the last module about planning at least one family meal together, without the TV.'
                ),
                _react2.default.createElement(
                  'h5',
                  null,
                  'Were you able to do this?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleableToEatWithoutTV.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'ableToEatWithoutTV', value: YES, checked: this.state.ableToEatWithoutTV === YES },
                    YES
                  ),
                  this.state.ableToEatWithoutTV === YES && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'That\'s great to hear. The more you eat together at the table with no television the better.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'ableToEatWithoutTV', value: NO, checked: this.state.ableToEatWithoutTV === NO },
                    NO
                  )
                )
              ),
              this.state.ableToEatWithoutTV === YES && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'Was it a pleasant experience?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleTVPleasant.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'tvPleasant', value: YES, checked: this.state.tvPleasant === YES },
                    YES
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'tvPleasant', value: NO, checked: this.state.tvPleasant === NO },
                    NO
                  )
                )
              ),
              this.state.tvPleasant === YES && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s great!'
                ),
                _react2.default.createElement(
                  'h5',
                  null,
                  'Did you find you talked more?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handledidTalkMore.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'didTalkMore', value: YES, checked: this.state.didTalkMore === YES },
                    YES
                  ),
                  this.state.didTalkMore === YES && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'That\'s great too!'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'didTalkMore', value: NO, checked: this.state.didTalkMore === NO },
                    NO
                  )
                )
              ),
              this.state.tvPleasant === NO && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s fantastic you had a go! I hope your next attempt is successful. It might also help to look at Module 3 resources about setting rules and resistance to change.'
                ),
                _react2.default.createElement(
                  'h5',
                  null,
                  'If you can give it another try, can you think of anything that you would do differently to increase your chances of success?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handledifferentToIncSuccess.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'differentToIncSuccess', value: YES, checked: this.state.differentToIncSuccess === YES },
                    YES
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'differentToIncSuccess', value: NO, checked: this.state.differentToIncSuccess === NO },
                    NO
                  )
                )
              ),
              this.state.differentToIncSuccess === NO && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s ok, initially it can be difficult to get children to sit and eat their meal but the more you do it, the more accepting your child will be. It might help to keep in mind the benefits of eating without the television on. These include encouraging family time, companionship, and enjoyment of food being eaten.'
                )
              ),
              this.state.ableToEatWithoutTV === NO && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s ok, perhaps you could have a think about what stopped you from being able to do this, this week. And think about how might be able to do it in the future.'
                ),
                _react2.default.createElement(
                  'h5',
                  null,
                  'Is there anything you could do differently?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handledoSomethingDifferent.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'doSomethingDifferent', value: YES, checked: this.state.doSomethingDifferent === YES },
                    YES
                  ),
                  this.state.doSomethingDifferent === YES && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'Great! Write down your suggestions to try next time!'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'doSomethingDifferent', value: NO, checked: this.state.doSomethingDifferent === NO },
                    NO
                  ),
                  this.state.doSomethingDifferent === NO && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'That\'s a shame. That sounds like it could have been frustrating, but you did the right thing and provided ready-to-eat healthy foods in an appealing way. If you providing healthy options it\'s likely that',
                      this.props.profile.childName,
                      ' will try them and get to like them.'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
              ),
              _react2.default.createElement('div', { className: styles.spacer100 })
            )
          )
        )
      );
    }
  }]);
  return Module3App1;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func,
  profile: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module3App1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/3/App/App1.js
// module id = 1196
// module chunks = 0